import { render, staticRenderFns } from "./bankinfo-info.vue?vue&type=template&id=306f600e&scoped=true&"
import script from "./bankinfo-info.vue?vue&type=script&lang=js&"
export * from "./bankinfo-info.vue?vue&type=script&lang=js&"
import style0 from "./bankinfo-info.vue?vue&type=style&index=0&id=306f600e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f600e",
  null
  
)

component.options.__file = "bankinfo-info.vue"
export default component.exports